import axios from '../axios/axios-auth'

export default class ImplementsService {
    getImplementsByOrgV3(orgId) {
        return axios.get(`/api/v3/organizations/${orgId}/implements`).then(response => response.data)
    }

    getOrganizationImplement(implementId) {
        return axios.get(`/api/v3/implements/${implementId}`).then(response => response.data)
    }

    saveImplement(orgId, implement) {
        return axios.post(`/api/v3/organizations/${orgId}/implements`, implement).then(response => response.data)
    }

    updateImplement(orgId, implementId, data) {
        return axios.patch(`/api/v3/implements/${implementId}`, data).then(response => response.data)
    }

    removeImplement(implementId) {
        return axios.delete(`/api/v3/implements/${implementId}`).then(response => response.data)
    }

    getImplementManufacturers() {
        return axios.get(`/api/v3/implement/manufacturers`).then(response => response.data)
    }

    findAllModelsByManufacturerId(manufacturerId) {
        return axios.get(`/api/v3/implement/manufacturers/${manufacturerId}/models`).then(response => response.data)
    }

    getImplement(modelId) {
        return axios.get(`/api/v3/implement/models/${modelId}`).then(response => response.data)
    }

    saveUserDeviceProfile(data) {
        return axios.post(`/api/v3/userDeviceProfiles`, data).then(response => response.data)
    }
}
